import axios from "axios";

const localEnvBack = import.meta.env.VITE_API_URL_TEST;

export const axiosInstance = axios.create({
  baseURL: `${localEnvBack}`,
});
